import type { IconProps } from "./types";

const defaultProps = {
  svgProps: {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    focusable: false,
    "aria-hidden": true,
  },
  pathProps: {
    fill: "currentColor",
  },
};

const Article = ({
  svgProps = defaultProps.svgProps,
  pathProps = defaultProps.pathProps,
}: IconProps) => {
  const mergedSvgProps = { ...defaultProps.svgProps, ...svgProps };
  const mergedPathProps = { ...defaultProps.pathProps, ...pathProps };
  return (
    <svg {...mergedSvgProps}>
      <path
        d="M3 3.9758V21.9758H21V3.9758H3ZM14 17.9758H7V15.9758H14V17.9758ZM17 13.9758H7V11.9758H17V13.9758ZM17 9.9758H7V7.9758H17V9.9758Z"
        {...mergedPathProps}
      />
    </svg>
  );
};

export default Article;
